import { useCallback, useState } from 'react';

import { TableColumn, TableFilter } from '../types';
import { filterMarshalling, filterUnmarshalling, setUrlParameters } from '../utils';

export function useFilter<I extends EntityBase = EntityBase>({ initial, columns, ignoreQuery }: { 
  initial?: TableFilter<I>[], 
  columns: TableColumn<I>[],
  ignoreQuery?: boolean
}) {
  const [filters, setFilters] = useState<TableFilter<I>[]>(() => {
    if (ignoreQuery) {
      return initial || filterUnmarshalling<I>({}, columns);
    }
    
    const query = new URLSearchParams(window.location.search); 
    const filterRaw = query.get('filter');
    
    let parsed: Record<string, string | string[]>;
    try {
      parsed = JSON.parse(filterRaw);
    } catch (e) {
      console.log(e);
    }
    
    return filterUnmarshalling<I>(parsed || {}, columns);
  });

  const setFilter = useCallback((filter: TableFilter<I>[]) => { 
    setFilters(filter);
     
    if (!ignoreQuery) {
      setUrlParameters({
        page: '1', 
        pageSize: '10',
        filter: JSON.stringify(filterMarshalling<I>(filter))
      });
    }
  }, [ignoreQuery]);

  return {
    filter: filters, 
    setFilter
  };
}